import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    uuid:'',//每个客户端的uuid
    onlyId:'',//每个手机的onlyid
    activityStatus:"",//判断活动的状态:1:活动期间 2:活动已结束，3:活动关闭 0:活动未开始
    activityId:"",//活动的id
    propList: [],//activeModal -> active 产品的列表
    cashcount: 0,//现金
    goldcount: 0,//金币,
    activeBagMap:{},//背包map
    time:'',//活动开启时间,
    firstEntry: [],//第一次进入页面的这个活动今天第一次展示
    freeact: [],
    guide:'',
    userName: '', //用户名
    userIcon: '', // 用户头像
    userToken: '', // 用户token
    isGuest: true // 是否游客登录
  }, 
  mutations: {
    setuuid(state, {uuid}){
      state.uuid = uuid
    },
    setonlyid(state, {onlyId}){
      state.onlyId = onlyId
    },
    setactivityId(state, {activityId}){
      state.activityId = activityId
    },
    setactivityStatus(state, {activityStatus}){
      state.activityStatus = activityStatus
    },
    setpropList(state, {propList}){
      state.propList = propList
    },
    setcashcount(state, {cashcount}){
      state.cashcount = cashcount
    },
    setgoldcount(state, {goldcount}){
      state.goldcount = goldcount
    },
    setactivebagmap(state, {activeBagMap}){
      state.activeBagMap = { ...activeBagMap }
    },
    settime(state, {time}){
      state.time = time
    },
    setfirstEntry(state, {firstEntry}){
      state.firstEntry = firstEntry
    },
    setfreeact(state, {freeact}){
      state.freeact = freeact
    },
    setguide(state, {guide}){
      state.guide = guide
    },
	  setuserName(state, {userName}){
      state.userName = userName
    },
    setuserIcon(state, {userIcon}){
      state.userIcon = userIcon
    },
    setuserToken(state, {userToken}){
      state.userToken = userToken
    },
    setIsGuest(state, { isGuest }){
      state.isGuest = isGuest
    },
  },
  actions: {

  },
  getters:{
    uuid: state => state.uuid,
    userName: state => state.userName,
    userIcon: state => state.userIcon,
    userToken: state => state.userToken,
    isGuest: state => state.isGuest
  }
})

export {
  store
};
